// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"emptyPlaceholderStyles_placeholder__3IBPe"};